import { useUserContext } from "@/context/UserContext";
import {
  getAuthorById,
  getCommentsByPhotoId,
  newCommentPhoto,
  newDiscussionPhoto,
  postImagesReplaced,
  viewImage,
} from "@/services/PhotosService";

function usePhotos() {
  const { userToken, currentUser } = useUserContext();

  async function viewPhoto(photoId: string) {
    return viewImage(photoId, currentUser ? currentUser._id : null);
  }

  async function getCreator(authorId: string) {
    return getAuthorById(authorId);
  }

  async function newCommentInPhoto(commentData: any, photoId: string) {
    return newCommentPhoto(commentData, photoId, userToken);
  }
  async function newDiscussionInPhoto(commentData: any, photoId: string) {
    return newDiscussionPhoto(commentData, photoId, userToken);
  }

  async function getPhotoComments(photoId: string) {
    return getCommentsByPhotoId(photoId);
  }

  async function postPhotoReplace(data: FormData | any) {
    return postImagesReplaced(data, userToken);
  }

  return {
    viewPhoto,
    getCreator,
    postPhotoReplace,
    newCommentInPhoto,
    getPhotoComments,
    newDiscussionInPhoto,
  };
}

export default usePhotos;
